/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ITefanAwwalCaseInput } from './../modules/szf-tefan-awal-form/szf-tefan-awal-form.view';
/**
 * PostTefanawwalForm Input Action
 */

 export interface ICategoryDataActionInput {
    fullName: string;
    contactNumber: string;
    email: string;
    emiratesID: string;
    nationality: string;
    categoryId: string;
    termsAndCondition: boolean;
    categories?: string[];
}
export class PostTefanawwalFormInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public token: string | undefined;
    public target: ICategoryDataActionInput[]
    constructor(data: ITefanAwwalCaseInput) {
        this.token=data.token;
        this.target = data.target;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `TEFANAWWALCASE`;
    public getCacheObjectType = () => 'TEFANAWWALCASE';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IPostTefanawwalFormData {
    status: boolean;
    msg: string | undefined;
    id: string | undefined;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const tefanAwwalCaseCreateInput = (args: Msdyn365.ICreateActionContext, inputData: ITefanAwwalCaseInput): Msdyn365.IActionInput => {
    return new PostTefanawwalFormInput(inputData);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function tefanAwwalDataAction(input: PostTefanawwalFormInput, ctx: Msdyn365.IActionContext): Promise<IPostTefanawwalFormData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    try{
        const token = input.token;
        const szfCRMDomainForTefanAwwal = ctx.requestContext.app.config.szfCRMDomainForTefanAwwal;
        const data = {
        Targets : input.target.map((i) => {
            return {
                    "szf_name" : i.fullName ? i.fullName : '',
                    "szf_Nationality@odata.bind" : `/szf_nationalities(${i.nationality ? i.nationality : ''})`,
                    "szf_Category@odata.bind" : `/szf_tefanalawwalcategories(${i.categoryId ? i.categoryId : ''})`,
                    "szf_emiratesid" : i.emiratesID ? i.emiratesID : '',
                    "szf_email" : i.email ? i.email : '',
                    "szf_contactnumber" : i.contactNumber ? i.contactNumber : '',
                    "szf_iacceptfield" : i.termsAndCondition ? i.termsAndCondition : '',
                    "@odata.type": "Microsoft.Dynamics.CRM.szf_tefanalawwal"
                };
            })
        }
        const response = await Msdyn365.sendRequest<any>(`${szfCRMDomainForTefanAwwal}/api/data/v9.1/szf_tefanalawwals/Microsoft.Dynamics.CRM.CreateMultiple`, "post", data, {
            timeout: 15000,
            headers: {
                'Prefer': 'return=representation',
                'Authorization':`Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }); 
        if(response && response.data && response.data.Ids && response.data.Ids.length > 0){
            return {
                status: true,
                msg: 'success',
                id: response.data.Ids[0]
            };
        }else if (response && response.data && response.data.error){
            return {
                status: false,
                msg: response.data.error.message,
                id: undefined
            };
        }else{
            return {
                status: false,
                msg: undefined,
                id: undefined
            };
        }
    }catch(error){
        return {
            status: false,
            id: undefined,
            msg: 'Something went wrong, Please try again later.'
        };
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPostTefanawwalFormData>>tefanAwwalDataAction,
    // TODO: Give your data action a unique id
    id: 'PostTefanawwalForm',
    input: tefanAwwalCaseCreateInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
